import React, { useState, useEffect, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { BufferService, LoadingContext, M_InputTextField, M_DrawerTableTextField, M_StateActions, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import './formsTable.css'

export default function CreateCustomerAddress() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [dataCustomerAddress, setDataCustomerAddress] = useState(new Map())
    const [optionsCustomerAddress, setOptionsCustomerAddress] = useState([])
    const [customerAddressId, setCustomerAddressId] = useState("")
    const [operation, setOperation] = useState("")
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const bufferServiceCustomerAddress = new BufferService('CustomerAddress')
    const { t } = useTranslation()
    const sessionKeys = ['dataCustomerAddress', 'optionsCustomerAddress', 'customerAddressId', 'operation']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
        // eslint-disable-next-line 
    }, [])

    // eslint-disable-next-line 
    useEffect(() => {
        const newId = M_State.filter(obj => obj.key === 'selectedTab')[0]?.value
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        const tempArray = []
        sessionKeys.forEach((key) => {
            tempArray.push(sessionStorageMachine(id, key, key))
        })
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, dataCustomerAddress, optionsCustomerAddress, customerAddressId, operation])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempDC = M_StateData.filter(obj => obj.key === `dataCustomerAddress`)[0]?.value
            const tempOC = M_StateData.filter(obj => obj.key === `optionsCustomerAddress`)[0]?.value
            const tempCI = M_StateData.filter(obj => obj.key === `customerAddressId`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            if (tempDC || tempOC || tempCI || tempOP) {
                setDataCustomerAddress(new Map(tempDC))
                setOptionsCustomerAddress(tempOC)
                setCustomerAddressId(tempCI)
                setOperation(tempOP)
                ctx.setIsLoad(false)
                return
            }
        }
        getCustomerAddress()
    }

    const getCustomerAddress = () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))
        setOperation(getOperation)
        setCustomerAddressId(getId)

        ctx.setIsLoad(true)
        bufferServiceCustomerAddress.options().then((responseOptions) => {
            if (responseOptions.name === 'AxiosError') {
                ctx.toastMessages('error', responseOptions.response.data.Errors[0], '')
                return
            }
            const filteredOptions = responseOptions.filter((option) => !option.IsHiddenList)
            setOptionsCustomerAddress(filteredOptions)

            if (getOperation === 'edit') {
                bufferServiceCustomerAddress.getId(getId).then((response) => {
                    if (response.name === 'AxiosError') {
                        ctx.toastMessages('error', response.response.data.Errors[0], '')
                        ctx2.closeTab(id)
                        return
                    }
                    const valueDataCustomerAddress = response
                    responseOptions.forEach(obj => {
                        dataCustomerAddress.set(obj.Name, valueDataCustomerAddress[obj.Name])
                    })
                    setDataCustomerAddress(new Map(dataCustomerAddress))
                    ctx.setIsLoad(false)
                })
            }
        })
        ctx.setIsLoad(false)
    }

    const customerAddressStructure = (event, index) => {
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            dataCustomerAddress.set(index, dateValue)
        } else {
            dataCustomerAddress.set(index, event)
        }
        setDataCustomerAddress(new Map(dataCustomerAddress))
    }

    const submitCustomerAddress = () => {
        const requiredFieldsCustomerAddress = optionsCustomerAddress.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsCustomerAddress) {
            if (!dataCustomerAddress.has(field.Name) || !dataCustomerAddress.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }
        ctx.setIsLoad(true)
        if (operation === 'edit') {
            bufferServiceCustomerAddress.update(customerAddressId, Object.fromEntries(dataCustomerAddress)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorUpdate"))
                    return
                }
                ctx.toastMessages("success", '', t("SuccessUpdate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceCustomerAddress.post(Object.fromEntries(dataCustomerAddress)).then((response) => {
                if (response.name === 'AxiosError') {
                    ctx.toastMessages("error", '', t("ErrorCreate"))
                    return
                }
                ctx.toastMessages("success", '', t("SuccessCreate"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    return (
        <div className='backgroundForms'>
            <div className="display">
                <div className="menuIcon">
                    <Tooltip title={t("Close")} className='iconsHeaderTable'>
                        <div className='iconsHeaderTable' onClick={() => ctx2.closeTab}>
                            <i className="pi pi-arrow-left iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Close")}</b></span>
                        </div>
                    </Tooltip>
                    <Tooltip title={t("Save")}>
                        <div className='iconsHeaderTable' onClick={submitCustomerAddress}>
                            <i className="pi pi-save iconTable"></i>
                            <span className='labelCRUDTable'><b>{t("Save")}</b></span>
                        </div>
                    </Tooltip>
                </div>
            </div>
            <div className='dividerMenu'></div>
            <div className='divDisplayFormTemplate'>
                {optionsCustomerAddress.map((elem) => (
                    <div key={elem.Name}>
                        {elem.Type === 'string' ? (
                            elem.IsForeignKey ? (
                                <M_DrawerTableTextField
                                    tableLabel={elem.NormalizedName}
                                    label={elem.NormalizedName}
                                    required={elem.Required}
                                    entity={elem.ForeignTableName}
                                    value={dataCustomerAddress.get(elem.ForeignTableToPassId) ?
                                        {
                                            [elem.ForeignTableToPassId]: dataCustomerAddress.get(elem.ForeignTableToPassId),
                                            [elem.ForeignKeyName]: dataCustomerAddress.get(elem.Name)
                                        } : null}
                                    filterField={elem.ForeignKeyName}
                                    labelFields={[elem.ForeignKeyName]}
                                    onSubmitValue={obj => {
                                        if (obj) {
                                            dataCustomerAddress.set(elem.Name, obj[elem.ForeignKeyName])
                                            dataCustomerAddress.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                        } else {
                                            dataCustomerAddress.set(elem.Name, null)
                                            dataCustomerAddress.set(elem.ForeignTableToPassId, null)
                                        }
                                        setDataCustomerAddress(new Map(dataCustomerAddress))
                                    }}
                                    disabled={elem.disable}
                                    valueField={elem.ForeignTableToPassId}
                                />
                            ) : (
                                < M_InputTextField
                                    type={"text"}
                                    label={elem.NormalizedName}
                                    secondColor={"var(--color-red-dark)"}
                                    required={elem.IsRequired}
                                    onChange={(e) => customerAddressStructure(e.target.value, elem.Name)}
                                    value={dataCustomerAddress.get(elem.Name) || ""}
                                />
                            )
                        ) : elem.Type === 'int32' ? (
                            < M_InputTextField
                                type={"number"}
                                label={elem.NormalizedName}
                                secondColor={"var(--color-red-dark)"}
                                required={elem.IsRequired}
                                onChange={(e) => customerAddressStructure(e.target.value, elem.Name)}
                                value={dataCustomerAddress.get(elem.Name) || ""}
                            />
                        ) : elem.Type === 'datetime' ? (
                            <M_InputTextField
                                type={"date"}
                                label={elem.NormalizedName}
                                secondColor={"var(--color-red-dark)"}
                                required={elem.IsRequired}
                                onChange={(e) => customerAddressStructure(e.target.value, elem.Name)}
                                value={dataCustomerAddress.get(elem.Name) || ""}
                            />
                        ) : ""}
                    </div>
                ))}
            </div>
        </div>
    )
}